// extracted by mini-css-extract-plugin
export default {"navbar":"KlnSINftRQVD6OAT26sj","menuLeft":"vpAixaw6zrGIVVyOB9Zt","shadow":"qBaXDggaTNwknjjTjPVa","placeHolderShimmer":"ESehsperH42Gvf9mETKh"};